import { render, staticRenderFns } from "./contenedor_ventas.vue?vue&type=template&id=033c6eb3&scoped=true"
import script from "./contenedor_ventas.vue?vue&type=script&lang=js"
export * from "./contenedor_ventas.vue?vue&type=script&lang=js"
import style0 from "./contenedor_ventas.vue?vue&type=style&index=0&id=033c6eb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033c6eb3",
  null
  
)

export default component.exports